import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameFooterBarBox} from "./boxes/game-footer-bar.box";
import {CyClass} from "../../../../common/cy-classes";

interface GameFooterBarComponentProps {
    gameContext: IGameContextViewModel;
    renderTopSection: () => React.ReactElement;
    renderBottomSection?: () => React.ReactElement;
}

export const GameFooterBarComponent = observer(
    class GameFooterBarComponent extends OrbitComponent<GameFooterBarComponentProps> {
        private _captureElementRef = (element: HTMLElement) => {
            if(element) {
                this.props.gameContext.gameParts.footerBarRenderer?.setGamePartElementRef(element);
            }
        }

        render() {
            return (
                <GameFooterBarBox ref={this._captureElementRef} className={CyClass('cy-game-footer-bar')}>
                    {this.props.renderTopSection()}
                    {this.props.renderBottomSection && this.props.renderBottomSection()}
                </GameFooterBarBox>
            )
        }
    }
);